<template>
	<div>
		<div class="load-bar" v-show="showprogressbar">
			<div class="bar"></div>
			<div class="bar"></div>
			<div class="bar"></div>
		</div>
		<vue-progress-bar></vue-progress-bar>
		<router-view :key="$route"></router-view>
	</div>
</template>
<script>
import Vue from "vue";
import VueResource from "vue-resource";
import VueCookie from "vue-cookie";
import VueProgressBar from "vue-progressbar";
import VueLocalStorage from "vue-localstorage";
import VueToastr from "@deveodk/vue-toastr";
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import CommonService from "./services/common";
import authService from "./services/authservice";
import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
import { KendoCalendar } from "@progress/kendo-dateinputs-vue-wrapper";
import {
	KendoGrid,
	KendoGridInstaller
} from "@progress/kendo-grid-vue-wrapper";
import {
	KendoDropDownList,
	KendoDropdownsInstaller
} from "@progress/kendo-dropdowns-vue-wrapper";
import {
	KendoDatePicker,
	KendoTimePicker,
	KendoDateinputsInstaller
} from "@progress/kendo-dateinputs-vue-wrapper";

import "./utilities/veeValidate";
import "./utilities/directive";
import moment from "moment";
import WebCam from 'vue-web-cam'
Vue.use(WebCam);


var requestCount = 1;
Vue.use(VueCookie);

Vue.use(KendoDateinputsInstaller);
Vue.use(KendoDropdownsInstaller);
Vue.use(KendoGridInstaller);
Vue.use(VueToastr, {
	defaultPosition: "toast-top-right",
	defaultType: "info",
	defaultTimeout: 5000
});

Vue.component(KendoCalendar.name, KendoCalendar);
Vue.component(KendoGrid.name, KendoGrid);

const options = {
	color: "#000000",
	failedColor: "#874b4b",
	thickness: "5px",
	transition: {
		speed: "0.2s",
		opacity: "0.6s",
		termination: 300
	},
	autoRevert: true,
	autoFinish: false
};

Vue.use(VueLocalStorage);
Vue.use(VueResource);
Vue.use(VueProgressBar, options);

Vue.http.options.root = "/api/";

if (window.location.hostname == "localhost") {
	Vue.http.options.root = "http://localhost:42621/api/";
	//Vue.http.options.root = "https://demo.eremit.com.my/api/";
}

Vue.http.interceptor.before = function(request, next) {
	//console.log(this.$router.app)
	if (request.url.indexOf(".json") !== -1) {
		request.root = "";
		request.headers.set("Cache-Control", "no-cache");
	}
	this.$Progress.start();

	request.headers.set("DeviceType", "WebApp");

	if (CommonService.isAuthenticated()) {
		request.headers.set("DeviceKey", CommonService.getAuthToken());
		authService.checkSession();
	}
	next();
};

Vue.http.interceptors.push(function(request, next) {
	next(function(response) {
		if (response.status == 401) {
			CommonService.logOut(true);
			this.$Progress.fail();
			this.$Progress.finish();
		} else {
			if (!response.ok) {
				var message =
					response.body === "" ||
					response.body[0].Message === undefined
						? "Internal Server Error."
						: response.body[0].Message;
				if(response.status == 429){
					message = "Please try again later.";
				}

				if(message === "Invalid Card"){
					kendo.confirm("Invalid Card. Please retry.").then(function () {
						window.location.href = '/dashboard';
					}, function () {
						window.location.href = '/dashboard';
					});
				}else{
					this.$toastr("error", message);
				}
				this.$Progress.fail();
			} else {
				this.$Progress.finish();
			}
		}
	});
});

export default {
	name: "app",
	components: {
		KendoCalendar,
		KendoGrid,
		KendoDropDownList
	},
	methods: {
		loadData: function() {
			$.get(
				"/api/data",
				function(response) {
					this.items = response.items;
				}.bind(this)
			);
		},
		showbar() {
			this.showprogress = true;
		},
		hidebar() {
			this.showprogress = false;
		}
	},
	data() {
		return { showprogressbar: false };
	},

	mounted() {
		//  [App.vue specific] When App.vue is finish loading finish the progress bar
		this.$Progress.finish();
		var interval = null;

		var self = this;

		window.addEventListener("keypress", e => {
			if (self.globalInternal != null) clearTimeout(self.globalInternal);

			self.globalInternal = setTimeout(() => {
				var isloggedin = CommonService.getStorage("token") !== null;
				if (isloggedin) {
					authService.checkSession();
				}
			}, 6000);
		});
	}
};
</script>

<style>
/* Import Font Awesome Icons Set */


/* Import Bootstrap Styles */
@import "~bootstrap/dist/css/bootstrap.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "../scss/flags.css";
/* @import '../scss/MainStyle.css';  */
</style>

<style lang="scss">
/*Import Main styles for this application*/
@import "./scss/style";
@import "./scss/passphrase";

@import "@/../static/custom/jquery.smartbanner";

body {
    font-family: 'Montserrat', sans-serif;
}
</style>

<style>
	@import "~font-awesome/css/font-awesome.min.css";
	@import "~simple-line-icons/css/simple-line-icons.css";
</style>
